export const CONSTANTS = Object.freeze({
  APP_DEFAULT_LEFTOVER: 5,
  APP_CONSIGNMENTS_EXPIRATION_LEFT: 10,
});